import { inject, Injectable } from "@angular/core";

import { AnalyticsService, EVENT_UAEVENT } from "@hermes/hermes-web-fragments-analytics";

const EVENT_CATEGORY_GEO_FILTERING = "GeoBanner";

@Injectable()
export class GeofilteringTrayAnalyticsService {
    private analyticsService = inject(AnalyticsService);

    public sendGeoFilteringViewEvent(event: string | null | undefined): void {
        this.analyticsService.sendRawData({
            event: "nonintuaevent",
            eventcategory: EVENT_CATEGORY_GEO_FILTERING,
            eventaction: "View",
            eventlabel: event,
        });
    }

    public sendGeoFilteringClickEvent(event: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: EVENT_CATEGORY_GEO_FILTERING,
            eventaction: "Click",
            eventlabel: event,
        });
    }

    public sendGeoFilteringCountrySelectorEvent(event: string): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: EVENT_CATEGORY_GEO_FILTERING,
            eventaction: "Country_Selector",
            eventlabel: event,
        });
    }
}
